export { default as IconSvg } from './IconSvg';
